<p>Clicca sul tasto per visualizzare l'opera all'interno del viewer geografico.</p>
<button type="button" tabindex="0" class="btn btn-primary"
    (click)="goToViewerOpera()"
    [disabled]="!permessiService.opera['OPERA_EDIT']">Apri viewer</button>